import React from 'react';

// Importa todas las secciones que el router puede renderizar
import DashboardContent from '../views/dashboard_sections/DashboardContent.js';
import CrearDeposito from '../views/dashboard_sections/CrearDeposito.js';
import MisAcuerdos from '../views/dashboard_sections/MisAcuerdos.js';
import FinanzasSection from '../views/dashboard_sections/Finanzas.js';
import Perfil from '../views/dashboard_sections/Perfil.js';
import EquiposDeTrabajo from '../views/dashboard_sections/Equipos.js';
import PequenosDuenos from '../views/dashboard_sections/PequenosDuenos.js';
import Notificaciones from '../views/dashboard_sections/Notificaciones.js';
import Noticias from '../views/dashboard_sections/Noticias.js';
import MisRetiros from '../views/dashboard_sections/MisRetiros.js';
import SoporteUsuario from '../views/dashboard_sections/SoporteUsuario.js';
import ClubBeneficios from '../views/dashboard_sections/ClubBeneficios.js';
import RankDetails from '../views/dashboard_sections/RankDetails.js';

const DashboardRouter = ({ activeSection, canSeeTeamAndCareer, handleNavClick, user, userProfile, agreements, transactions, withdrawals, kpiData, chartData, financialSummary, teamData, loadingTeam, errorTeam }) => {
    // La lógica de 'fd' ya no es necesaria, los datos vienen directamente del hook principal.

    switch (activeSection) {
        case 'dashboard':
            return <DashboardContent 
                        kpiData={kpiData} 
                        chartData={chartData} 
                        financialSummary={financialSummary} 
                        agreements={agreements} 
                        transactions={transactions}
                        onViewAllClick={() => handleNavClick('acuerdos')}
                        userProfile={userProfile}
                        showTeamAndCareer={canSeeTeamAndCareer}
                    />;
        case 'suscripcion':
            return <CrearDeposito onAgreementCreated={() => handleNavClick('dashboard')} />;
        case 'acuerdos':
            return <MisAcuerdos agreements={agreements} user={user} profileData={userProfile} financialSummary={financialSummary} transactions={transactions} />;
        case 'finanzas':
            return <FinanzasSection profileData={userProfile} transactions={transactions} financialSummary={financialSummary} />;
        case 'perfil':
            return <Perfil user={user} profileData={userProfile} agreements={agreements || []} />;
        case 'teams':
            return <EquiposDeTrabajo profileData={userProfile} teamData={teamData} transactions={transactions} loading={loadingTeam} error={errorTeam} />;
        case 'small-owners':
            return <PequenosDuenos user={user} profileData={userProfile} />;
        case 'notificaciones':
            return <Notificaciones notifications={transactions || []} onNavClick={handleNavClick} />;
        case 'news':
            return <Noticias />;
        case 'retiros':
            return <MisRetiros withdrawals={withdrawals} />;
        case 'soporte':
            return <SoporteUsuario />;
        case 'club-beneficios':
            return <ClubBeneficios />;
        case 'rank-details':
            return <RankDetails profileData={userProfile} />;
        default:
            return <div className="main-panel"><h2>En Construcción</h2></div>;
    }
};

export default DashboardRouter;